export default "__VITE_ASSET__BsLZquhK__"